// src/data/books/FundamentosBlockchain/data/cap4.js
const BLOCKCHAIN_FUNDAMENTOS_CH04 = {
  id: "blockchain-fundamentos-4",
  slug: "tipos-de-blockchains",
  contentId: 4,
  title: "Tipos de Blockchains",
  sections: [
    {
      id: "hero",
      heading: "Tipos de Blockchains",
      text: `En este capítulo describimos cuatro enfoques habituales para desplegar redes basadas en blockchain: públicas, federadas (o de consorcio), privadas y Blockchain as a Service (BaaS). 
Cada modelo implica decisiones diferentes en cuanto a acceso, gobierno, transparencia, seguridad y costos de operación.`
    },
    {
      id: "publicas",
      heading: "Públicas",
      text: `Las redes públicas permiten el acceso abierto a cualquier persona. 
Para participar, el usuario suele descargar un cliente y conectarse automáticamente a varios nodos que mantienen la versión más actualizada de la cadena. 
Una vez sincronizado, el nodo posee los mismos derechos y deberes que el resto: proponer/validar transacciones, replicar información y, si lo desea, minar o participar en el mecanismo de consenso. 
La seguridad descansa en protocolos de consenso (p. ej., PoW, PoS) y funciones hash; los participantes, por lo general, interactúan de forma seudónima.`
    },
    {
      id: "federadas",
      heading: "Federadas (Consorcio)",
      text: `Las blockchains federadas son operadas por un conjunto delimitado de organizaciones que administran la red y mantienen copias sincronizadas. 
En vez de exponer nodos completos a los usuarios finales, el acceso suele darse mediante una interfaz web provista por los administradores. 
Esto exige un diseño organizacional claro: quién gobierna la red, qué permisos existen, qué datos se muestran a cada perfil de usuario y bajo qué reglas se procesan y auditan las transacciones. 
A menudo no existe una criptomoneda asociada ni incentivos de minado con recompensas; aun así, los bloques conservan hashes y se requiere infraestructura para producirlos (servidores provistos por las entidades del consorcio). 
Existen plataformas de código abierto orientadas a consorcios como Hyperledger, Corda, EFW o Multichain; también pueden hacerse forks de redes públicas (p. ej., Ethereum) para usos federados o privados.`
    },
    {
      id: "privadas",
      heading: "Privadas",
      text: `En una blockchain privada, una sola entidad controla la red: concede permisos, valida transacciones y decide la incorporación de bloques. 
Comparte rasgos con las federadas, pero con gobierno centralizado en una única organización, lo que elimina la descentralización y concentra la administración, los controles de acceso y la evolución del sistema.`
    },
    {
      id: "baas",
      heading: "Blockchain as a Service (BaaS)",
      text: `BaaS ofrece infraestructura y servicios administrados en la nube para desplegar redes y aplicaciones de blockchain. 
Proveedores como IBM (Hyperledger Fabric), Amazon (colaboraciones con DCG) o Microsoft (oferta sobre R3, Hyperledger Fabric o Quorum, entre otras) brindan entornos gestionados. 
Las ventajas típicas incluyen mayor seguridad administrada, menor inversión inicial en hardware y una experiencia de despliegue más amigable (por ejemplo, creación de canales/redes sin programar toda la infraestructura).`
    },
   



 {
  id: "comparativa-redes",
  heading: "Tipos de Redes Ventajas/Desventajas",
  text: `Comparación general entre redes públicas, federadas y privadas.`,
  table: {
    columns: ["Tipo", "Control/Permisos", "Ventajas", "Desventajas", "Casos Comunes"],
    rows: [
      {
        Tipo: "Pública",
        "Control/Permisos": "Abierta; cualquiera puede participar y operar nodo",
        Ventajas:
          "Alta transparencia; no hay administradores; igualdad de derechos; seguridad por consenso y funciones hash; smart contracts; soluciona problemas de confianza",
        Desventajas:
          "Rendimiento y costos variables; gobernanza comunitaria más lenta; recompensas/minería dependen de la red",
        "Casos Comunes": "Criptoactivos (BTC/ETH), DeFi, NFTs, identidad autosoberana"
      },
      {
        Tipo: "Privada",
        "Control/Permisos": "Un único administrador otorga permisos y valida",
        Ventajas:
          "Alto rendimiento; control de acceso fino; cumplimiento y trazabilidad interna; smart contracts",
        Desventajas:
          "Baja transparencia; centralización y punto único de control; sin minería con incentivos; menor resistencia a la censura",
        "Casos Comunes": "Auditoría interna, gestión documental, procesos corporativos"
      },
      {
        Tipo: "Federada",
        "Control/Permisos": "Varios administradores (consorcio) comparten gobernanza",
        Ventajas:
          "Equilibrio entre eficiencia y cooperación inter-empresarial; smart contracts; políticas de transparencia configurables",
        Desventajas:
          "No abierta al público; sin minería con recompensas; confianza delegada en miembros del consorcio",
        "Casos Comunes": "Banca y pagos B2B, cadenas de suministro, energía, registros compartidos"
      },
      {
        Tipo: "BaaS",
        "Control/Permisos": "Servicios en la nube (IBM, Microsoft, Amazon) para redes públicas/federadas/privadas",
        Ventajas:
          "Despliegue rápido; seguridad y operación gestionadas; menor CAPEX; tooling y monitoreo integrados",
        Desventajas:
          "Dependencia del proveedor (vendor lock-in); ‘NA’ en apertura/transparencia propias (depende del tipo de red que se monte)",
        "Casos Comunes": "Prototipos y pilotos, entornos gestionados, escalado ágil de redes empresariales"
      }
    ]
  },
  subsections: [
    {
      id: "baas",
      heading: "Blockchain as a Service (BaaS)",
      text: `Empresas tecnológicas como IBM, AWS y Microsoft ofrecen soluciones de Blockchain en la nube,
permitiendo a las organizaciones implementar redes privadas o federadas sin gestionar la infraestructura completa.`
    }
  ]
},


  ]
};

export default BLOCKCHAIN_FUNDAMENTOS_CH04;
